import i18next from "i18next"
import { initReactI18next } from "react-i18next"

let language = process.env.LANGUAGE

let resources = {
    de: {
        translations: require("../locales/de/translations.json"),
    },
}

i18next.use(initReactI18next).init({
    resources: resources,
    lng: language,
    ns: ["translations"],
    defaultNS: "translations",
    returnObjects: true,
    debug: process.env.NODE_ENV === "development",
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: true,
    },
})

export default i18next
